(() => {
  function init(root) {
    root.querySelectorAll('[data-cw-calculator]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      form.addEventListener('submit', event => {
        event.preventDefault();
        const get = name => Number(form.elements.namedItem(name).value);
        const watts=get('watts'),hours=get('hours'),days=get('days'),tariff=get('tariff'),duty=get('duty');
        const required=['watts','hours','days','tariff','duty'].every(name=>form.elements.namedItem(name).value.trim()!=='');
        const valid=required&&[watts,hours,days,tariff,duty].every(Number.isFinite)&&watts>=0&&watts<=100000&&hours>=0&&hours<=24&&Number.isInteger(days)&&days>=1&&days<=366&&tariff>=0&&tariff<=100000&&duty>=1&&duty<=100;
        form.querySelector('[data-cw-error]').hidden=valid;
        form.querySelector('[data-cw-results]').hidden=!valid;
        if(!valid) return;
        const energy=watts/1000*hours*duty/100, currency=form.elements.namedItem('currency').value;
        const locale=document.documentElement.lang||'en-GB';
        const money=new Intl.NumberFormat(locale,{style:'currency',currency,minimumFractionDigits:2,maximumFractionDigits:2});
        form.querySelector('[data-cw-energy]').textContent=new Intl.NumberFormat(locale,{maximumFractionDigits:3}).format(energy)+' kWh';
        form.querySelector('[data-cw-daily]').textContent=money.format(energy*tariff);
        form.querySelector('[data-cw-total]').textContent=money.format(energy*tariff*days);
      });
      form.addEventListener('input',()=>{form.querySelector('[data-cw-results]').hidden=true;form.querySelector('[data-cw-error]').hidden=true;});
    });
    root.querySelectorAll('[data-cw-finder]').forEach(form=>{
      if(form.dataset.ready) return;
      form.dataset.ready='true';
      const copy=JSON.parse(form.querySelector('[data-cw-finder-copy]').textContent);
      form.addEventListener('submit',event=>{
        event.preventDefault();
        form.querySelector('[data-cw-part-result]').textContent=copy[form.elements.namedItem('part').value];
        form.querySelector('[data-cw-supply-result]').textContent=copy[form.elements.namedItem('supply').value];
        form.querySelector('[data-cw-setting-result]').textContent=copy[form.elements.namedItem('setting').value];
        form.querySelector('[data-cw-finder-result]').hidden=false;
      });
      form.addEventListener('change',()=>{form.querySelector('[data-cw-finder-result]').hidden=true;});
    });
    root.querySelectorAll('[data-cw-print]').forEach(button=>{if(button.dataset.ready)return;button.dataset.ready='true';button.addEventListener('click',()=>window.print());});
  }
  init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();